<div
  class="tw-flex tw-items-start lg:tw-items-center tw-gap-3 tw-px-5 tw-py-4 tw-border tw-rounded-lg tw-bg-white tw-font-inter tw-transition-colors tw-duration-200"
  [ngClass]="{
    'tw-border-blue-600': isDragging() || isHighlighted() || isFocused(),
    'tw-shadow-[0_0_12px_rgba(37,99,235,0.25)]': isHighlighted() || isFocused(),
    'tw-border-gray-200': !isDragging() && !isHighlighted() && !isFocused()
  }"
>
  <div class="tw-flex tw-flex-col tw-gap-3 tw-flex-1">
    <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full">
      <p class="tw-text-gray-500 tw-text-xs tw-font-inter tw-px-1">Zone name</p>
      <basic-input
        [control]="nameControl"
        [mode]="BasicInputMode.INLINE"
        [placeholder]="'Zone name'"
        [allowClearButton]="false"
        [id]="'zone-name-' + zone().id"
        class="tw-w-full"
        [autofocus]="isHighlighted()"
        (onFocusInput)="onFieldFocus()"
        (onBlurValueChange)="onNameBlur($event); onFieldBlur()"
      ></basic-input>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full">
      <p class="tw-text-gray-500 tw-text-xs tw-font-inter tw-px-1">Max capacity</p>
      <basic-input
        [control]="capacityControl"
        [mode]="BasicInputMode.INLINE"
        [placeholder]="'Max capacity'"
        [allowClearButton]="false"
        [id]="'zone-capacity-' + zone().id"
        (onKeydown)="onCapacityKeydown($event)"
        (onFocusInput)="onFieldFocus()"
        (onBlurValueChange)="onFieldBlur()"
        class="tw-w-full"
      ></basic-input>
    </div>
  </div>

  <button
    type="button"
    class="zone-delete-btn tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-rounded-md tw-text-gray-500 hover:tw-bg-red-50 hover:tw-text-red-600 tw-transition-colors"
    aria-label="Delete zone"
    (pointerdown)="onDeleteClicked($event, false)"
    (click)="onDeleteClicked($event, true)"
  >
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M17.4223 4.04211H13.5112V2.02105C13.5112 1.48504 13.3051 0.970973 12.9384 0.591953C12.5717 0.212932 12.0743 0 11.5556 0H7.64449C7.12585 0 6.62844 0.212932 6.26171 0.591953C5.89497 0.970973 5.68894 1.48504 5.68894 2.02105V4.04211H1.77783C1.5185 4.04211 1.2698 4.14857 1.08643 4.33808C0.903064 4.52759 0.800049 4.78462 0.800049 5.05263C0.800049 5.32064 0.903064 5.57767 1.08643 5.76718C1.2698 5.95669 1.5185 6.06316 1.77783 6.06316H2.7556V17.1789C2.7556 17.715 2.96164 18.229 3.32837 18.608C3.69511 18.9871 4.19251 19.2 4.71116 19.2H14.4889C15.0076 19.2 15.505 18.9871 15.8717 18.608C16.2385 18.229 16.4445 17.715 16.4445 17.1789V6.06316H17.4223C17.6816 6.06316 17.9303 5.95669 18.1137 5.76718C18.297 5.57767 18.4 5.32064 18.4 5.05263C18.4 4.78462 18.297 4.52759 18.1137 4.33808C17.9303 4.14857 17.6816 4.04211 17.4223 4.04211ZM7.64449 2.02105H11.5556V4.04211H7.64449V2.02105ZM8.62227 15.1579C8.62227 15.4259 8.51926 15.6829 8.33589 15.8724C8.15252 16.062 7.90382 16.1684 7.64449 16.1684C7.38517 16.1684 7.13647 16.062 6.9531 15.8724C6.76973 15.6829 6.66672 15.4259 6.66672 15.1579V8.08421C6.66672 7.8162 6.76973 7.55917 6.9531 7.36966C7.13647 7.18015 7.38517 7.07368 7.64449 7.07368C7.90382 7.07368 8.15252 7.18015 8.33589 7.36966C8.51926 7.55917 8.62227 7.8162 8.62227 8.08421V15.1579ZM12.5334 15.1579C12.5334 15.4259 12.4304 15.6829 12.247 15.8724C12.0636 16.062 11.8149 16.1684 11.5556 16.1684C11.2963 16.1684 11.0476 16.062 10.8642 15.8724C10.6808 15.6829 10.5778 15.4259 10.5778 15.1579V8.08421C10.5778 7.8162 10.6808 7.55917 10.8642 7.36966C11.0476 7.18015 11.2963 7.07368 11.5556 7.07368C11.8149 7.07368 12.0636 7.18015 12.247 7.36966C12.4304 7.55917 12.5334 7.8162 12.5334 8.08421V15.1579Z" fill="#E02424"/>
    </svg>
  </button>
</div>
